/**
 * @generated SignedSource<<1d0ff4df84ab84e335d6aa138e921ff5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StatusTooltipContentPopulateEmbeddingsMutation$variables = Record<PropertyKey, never>;
export type StatusTooltipContentPopulateEmbeddingsMutation$data = {
  readonly populateEmbeddings: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type StatusTooltipContentPopulateEmbeddingsMutation = {
  response: StatusTooltipContentPopulateEmbeddingsMutation$data;
  variables: StatusTooltipContentPopulateEmbeddingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PopulateEmbeddingsResult",
    "kind": "LinkedField",
    "name": "populateEmbeddings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StatusTooltipContentPopulateEmbeddingsMutation",
    "selections": (v0/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StatusTooltipContentPopulateEmbeddingsMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0626a5bb185f7fde1fb169aa22968e1d",
    "id": null,
    "metadata": {},
    "name": "StatusTooltipContentPopulateEmbeddingsMutation",
    "operationKind": "mutation",
    "text": "mutation StatusTooltipContentPopulateEmbeddingsMutation {\n  populateEmbeddings {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "17268780acdab788fb2c0bf7e4a9ca3e";

export default node;
